import React, { FC, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Company from '../../../page-module/page-services/company/ts/company';
import MainOutlet from '../../../layout-module/layout-configuration/outlet/ts/outlet';
import Career from '../../../page-module/page-services/career/ts/career';
import Contact from '../../../page-module/page-services/contact/ts/contact';
import JobDetail from '../../../page-module/page-services/job-detail/ts/jobDetail';
import JobPosition from '../../../page-module/page-services/job-position/ts/jobPosition';
import Product from '../../../page-module/page-services/product/ts/product';
import SaleContact from '../../../page-module/page-services/sales-contact/ts/salesContact';
import BusinessContact from '../../../page-module/page-services/bussiness-contact/ts/businessContact';
import ScrollToTop from '../controller-route/ts/scrollBehaviour';
import JPOulet from '../../../layout-module/layout-configuration/outlet/ts/jpOutlet';
import {  preloadStartupRoutesAndData } from '../../../context-module/context-configuration/auth-provider/preloadPage/preloadStartupRoutes';

const RouterIndex: FC = () => {

    useEffect(() => {
        // optionally idle
        if ("requestIdleCallback" in window) { //NOSONAR
            requestIdleCallback(() => preloadStartupRoutesAndData());
        } else {
            setTimeout(preloadStartupRoutesAndData, 200);
        }
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <Routes>

                <Route
                    path="/"
                    element={
                        <MainOutlet />
                    }
                >
                    {/* default redirect */}
                    <Route index element={<Navigate to="product" replace />} />

                    {/* child routes (NO leading slash!) */}
                    <Route path="company" element={<Company />} />

                    <Route path="career">
                        <Route index element={<Career />} />
                        <Route path="position/:nameId/code/:codeId" element={<JobDetail />} />
                        <Route path="position" element={<JPOulet />} >
                            <Route path="all" element={<JobPosition />} />
                        </Route>
                    </Route>


                    <Route path="contact">
                        <Route index element={<Contact />} />
                        <Route path="business-contact" element={<BusinessContact />} />
                        <Route path="sales-contact" element={<SaleContact />} />
                    </Route>

                    <Route path="product" element={<Product />} />



                </Route>

                <Route path="*" element={<Navigate to="/product" replace />} />
            </Routes>
        </Router>
    )
}

export default RouterIndex;
